import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'cpFilter'
})
export class FilterPipe implements PipeTransform {
	transform(arr: string[]|any[], q: string,propertyName?:string,propertyFunc?:Function): string[]|any[] {
		if (!q || !arr) {
			return arr;
		}
		return arr.filter(v =>((
			(propertyName?
				(propertyFunc?propertyFunc(v[propertyName]):v[propertyName])
				: propertyFunc?propertyFunc(v):v)+'').toLowerCase()).includes(q.toLowerCase()));
	}
}
